import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import WebCamImage from 'components/Image';
import Icon from 'components/Icon';

import css from './WebcamBlockBody.module.scss';

class WebcamBlockBody extends React.PureComponent {
    static propTypes = {
        "webcamImage": PropTypes.object,
        "text": PropTypes.string,
        "webcamErrorLabel": PropTypes.string,
        "anchorName": PropTypes.string,
    }

    state = {
        failed: false,
    }

    componentDidMount() {
        const image = new Image();
        image.onerror = () => {
            this.setState({ failed: true });
        }
        image.src = this.props.webcamImage.image;
    }

    render() {
        const {
            webcamImage,
            text,
            webcamErrorLabel,
            anchorName,
        } = this.props;


        const {
            failed,
        } = this.state;

        return (
            <section className={css.block} id={anchorName}>
                {!failed && (
                    <div>
                        <div className={css.image}>
                        <WebCamImage image={webcamImage}/>
                        </div>
                        <div className={css.icon}>
                            <Icon icon="camera-tripod-24px" />
                        </div>
                    </div>
                )}
                {failed && (
                    <div className={css.failed}>
                        <Icon icon="camera-tripod-24px" />

                        <div className={css.failedlabel}>
                            {webcamErrorLabel}
                        </div>
                    </div>
                )}
                <div className={css.caption}>
                    {text}
                </div>
                
            </section>
        );
    }
}

export default WebcamBlockBody;



// WEBPACK FOOTER //
// ./src/components/WebcamBlockBody/WebcamBlockBody.jsx